import { z } from 'zod';
import type { Locale } from './locales';
import { LOCALE_TAG } from './locales';

/** Currencies. Both stored explicitly per car / fee — no runtime FX (constitution C-08). */
export const CURRENCIES = ['EUR', 'CVE'] as const;
export type Currency = (typeof CURRENCIES)[number];

export const DEFAULT_CURRENCY: Currency = 'EUR';

export const currencySchema = z.enum(CURRENCIES);

/**
 * Format a currency amount via Intl.NumberFormat.
 * EUR shows 2 decimals; CVE shows 0 (the escudo doesn't subdivide in practice).
 */
export function formatCurrency(amount: number, currency: Currency, locale: Locale): string {
  return new Intl.NumberFormat(LOCALE_TAG[locale], {
    style: 'currency',
    currency,
    minimumFractionDigits: currency === 'CVE' ? 0 : 2,
    maximumFractionDigits: currency === 'CVE' ? 0 : 2,
  }).format(amount);
}
